import React from 'react';
import { StyledBigTextCenter } from './StyledBigTextCenter';

const BigTextCenter = ({ title, subtitle }) => {
  return (
    <React.Fragment>
      {
       
          <StyledBigTextCenter
          >
            
              <h5 className="big--title">
                {title}
              </h5>
              {
                subtitle && 
                <p className="preset-10">{subtitle}</p>
              }
            
            
          </StyledBigTextCenter>
          
      }
    </React.Fragment>
  );
};

export default BigTextCenter;
